export default {
  getUniqueId: () => Math.random().toString(),
  getSystemVersion: () => '1.0.0',
  getReadableVersion: () => '1.0.0.0',
};
